<template lang="pug">
    v-menu(
        bottom
        origin='center center'
        transition='scale-transition'
        v-model="tagMenu"
        offset-y
        v-if="menuTags && menuTags.length > 0"
    )
        template(v-slot:activator='{ on }')
            v-btn(color="var(--white)" light v-on='on' small)
                | Shortcuts
                v-icon
                    | mdi-chevron-down
        v-list
            v-list-item(
                v-for='(tag, i) in menuTags'
                :key='i'
                style="padding-right: 0; padding-left: 0;"
            )
                v-menu(
                    origin='center center'
                    transition='scale-transition'
                    open-on-hover
                    offset-x
                    max-height="60vh"
                    right
                )
                    template(v-slot:activator='{ on }')
                        v-btn.override-btn.text-left(color="var(--white)" light v-on='on' block depressed style="height: 100%;")
                            v-list-item-content
                                v-list-item-title {{ tag.name }}
                            v-list-item-action
                                v-icon mdi-menu-right
                    v-list
                        v-list-item(
                            v-for='(t, j) in tag.templates'
                            :key='j'
                            @click='handleClick(t);'
                            ripple
                        )
                            template(v-if="type === 'message'")
                                v-list-item-content
                                    v-list-item-title {{ t.message_template_name }}
                                    v-list-item-subtitle {{ t.language_name }}
                            template(v-else-if="type === 'email'")
                                v-list-item-content
                                    v-list-item-title {{ t.email_template_name }}
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                tagMenu: false,
            }
        },
        methods: {
            handleClick(template) {
                this.tagMenu = false;
                this.applyMessageTemplate(template);
            },
        },
        computed: {
        },
        components: {
        },
        props: {
            applyMessageTemplate: Function,
            menuTags: Array,
            type: {
                type: String,
                required: true,
            }
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .override-btn {
            font-weight: 400;
            letter-spacing: normal;
            text-decoration: none;
            text-transform: none;
        }
    }
</style>
